import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

const getServiceOrderLineComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/ServiceOrder/ServiceOrderLineComparisonInfoD365`,
        payload,
    );
    return response.data;
};

export const useGetServiceOrderLineComparison = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const inventoryLotId = payload.keys.inventoryLotId as string;
    const lineNumber = payload.keys.lineNumber as number;
    const serviceOrderID = payload.keys.serviceOrderID as number;

    // Both lineNumber (CS key) and inventoryLotId (D365 key) are required.
    // Service orders pair CS↔D365 lines by ItemNumber in document order;
    // the explorer node carries both identifiers and passes both to the comparison call.
    const enabled = Boolean(
        serviceOrderID > 0 && dataAreaId && lineNumber > 0 && inventoryLotId,
    );

    return useQuery<IComparisonInfo[]>({
        queryKey: [
            "GetServiceOrderLineComparisonInfoD365",
            {
                serviceOrderID: serviceOrderID ?? null,
                dataAreaId: dataAreaId ?? null,
                inventoryLotId: inventoryLotId ?? null,
                lineNumber: lineNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!enabled) {
                throw new Error(
                    "Invalid params for GetServiceOrderLineComparisonInfoD365",
                );
            }
            return getServiceOrderLineComparison(payload);
        },
        enabled,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
